import React, { useEffect, useState } from 'react'
import axios from 'axios'
import { Button, Card, Form } from 'react-bootstrap'
import toast from 'react-hot-toast'
import { FaEye, FaEyeSlash } from 'react-icons/fa'
import { BsArrowClockwise } from 'react-icons/bs'
import Cookies from 'js-cookie'
import ApiEndpoints, { BASE_URL } from './commonComponents/ApiEndpoints'
import { useAuth } from './AuthContext'
import { useSidebar } from './SidebarContext'
import ProfileDropdown from './commonComponents/ProfileDropdown'
import { useInstitute } from './commonComponents/InstituteContext'
import { LuGraduationCap } from 'react-icons/lu'

export default function ChangePassword() {
  const { logout } = useAuth()
  const { isCollapsed } = useSidebar()
  const [marginLeft, setMarginLeft] = useState('0px')
  const [isMobile, setIsMobile] = useState(
    typeof window !== 'undefined' ? window.innerWidth <= 768 : false,
  )
  const [logoError, setLogoError] = useState(false)
  const { logo } = useInstitute()

  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth >= 992) {
        const expandedWidth = 245
        const collapsedWidth = 85
        const gap = 1

        setMarginLeft(
          isCollapsed
            ? `${collapsedWidth + gap}px`
            : `${expandedWidth + gap}px`,
        )
      } else {
        setMarginLeft('0px')
      }

      setIsMobile(window.innerWidth <= 768)
    }

    handleResize()
    window.addEventListener('resize', handleResize)
    return () => window.removeEventListener('resize', handleResize)
  }, [isCollapsed])

  // const { user } = useAuth()
  const [formData, setFormData] = useState({
    old_password: '',
    new_password: '',
  })
  const [showOldPassword, setShowOldPassword] = useState(false)

  const [showNewPassword, setShowNewPassword] = useState(false)
  const [newPasswordMessage, setNewPasswordMessage] = useState('')

  const handleChange = (e) => {
    const { name, value } = e.target
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }))
  }
  const handleSubmit = async (e) => {
    e.preventDefault()
    try {
      const user = Cookies.get('user')
      console.log('Token : ', user)
      const parsedToken = JSON.parse(user)
      const token = parsedToken.token
      console.log('formData', formData)
      const response = await axios.post(
        BASE_URL + '/change-password',
        formData,
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      )

      console.log(response.data.message)
      toast.success(response.data.message)
      setNewPasswordMessage(formData.new_password)
      setShowOldPassword(false)
      setShowNewPassword(false)
    } catch (error) {
      toast.error(error.response?.data?.message)
    }
  }
  const oldPasswordVisible = () => {
    setShowOldPassword(!showOldPassword)
  }
  const newPasswordVisible = () => {
    setShowNewPassword(!showNewPassword)
  }
  const handleRefresh = () => {
    setNewPasswordMessage(!newPasswordMessage)
    window.location.reload()
  }
  return (
    <div
      style={{
        marginLeft,
        transition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
        willChange: 'margin-left',
        WebkitTransition: 'margin-left 0.35s cubic-bezier(0.4, 0, 0.2, 1)',
        position: 'relative',
        zIndex: 1,
        marginTop: '0px',
        paddingLeft: isCollapsed ? '12px' : '12px',
        paddingRight: isCollapsed ? '12px' : '12px',
      }}
    >
      {/* Header — matches Settings / Certificate */}
      <div
        className="container-fluid p-0"
        style={{
          marginTop: window.innerWidth < 992 ? '55px' : '-12px',
          paddingLeft: '0px',
          paddingRight: '0px',
        }}
      >
        <div style={{ marginLeft: isMobile ? '-13px' : '-40px' }}>
          <div
            className="d-flex justify-content-between align-items-center"
            style={{
              background: '#F3F4F6',
              paddingLeft: '28px',
              paddingRight: '28px',
              paddingTop: '12px',
              paddingBottom: '12px',
              overflow: 'visible',
              borderBottom: '1px solid #D1D3D4',
              width: '100%',
            }}
          >
            <div className="d-flex align-items-center gap-3 min-w-0">
              <div
                style={{
                  width: '40px',
                  height: '40px',
                  borderRadius: '50%',
                  overflow: 'hidden',
                  background: '#223843',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  flexShrink: 0,
                }}
              >
                {!logoError ? (
                  <img
                    src={logo}
                    alt="School Logo"
                    style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                    onError={() => setLogoError(true)}
                  />
                ) : (
                  <LuGraduationCap size={20} style={{ color: '#ffffff' }} />
                )}
              </div>

              <div className="min-w-0">
                <h3
                  className="m-0 fw-bold text-start"
                  style={{
                    letterSpacing: '-0.02em',
                    overflow: 'hidden',
                    textOverflow: 'ellipsis',
                    whiteSpace: 'nowrap',
                    fontSize: 'clamp(18px, 2.5vw, 22px)',
                    color: '#223843',
                    lineHeight: '1.2',
                    fontFamily: 'Inter, system-ui, sans-serif',
                  }}
                >
                  Change password
                </h3>
                <p
                  className="m-0 mt-1 text-start"
                  style={{
                    fontSize: isMobile ? '11px' : '13px',
                    color: '#6b7280',
                    fontWeight: '400',
                    fontFamily: 'Inter, system-ui, sans-serif',
                  }}
                >
                  Update your account password securely.
                </p>
              </div>
            </div>

            {!isMobile && <ProfileDropdown logout={logout} />}
          </div>
        </div>
      </div>

      <div
        className="container-fluid p-0 mt-4"
        style={{
          paddingLeft: isCollapsed ? '32px' : '40px',
          paddingRight: '32px',
          paddingTop: '8px',
          paddingBottom: '48px',
          maxWidth: '720px',
        }}
      >
        <Card
          style={{
            border: '1px solid #D1D3D4',
            borderRadius: '12px',
            overflow: 'hidden',
            backgroundColor: '#ffffff',
          }}
        >
          <div
            className="d-flex align-items-center justify-content-between flex-wrap gap-2"
            style={{
              padding: '16px 20px',
              borderBottom: '1px solid #E5E7EB',
              background: '#FAFAFA',
            }}
          >
            <p
              className="mb-0 fw-semibold"
              style={{
                fontFamily: 'Inter, system-ui, sans-serif',
                fontSize: '15px',
                color: '#111827',
              }}
            >
              Please create a new password
            </p>
            <button
              type="button"
              onClick={handleRefresh}
              title="Refresh"
              className="d-inline-flex align-items-center justify-content-center border-0 bg-transparent"
              style={{
                color: '#6b7280',
                padding: '6px',
                borderRadius: '8px',
                cursor: 'pointer',
              }}
              aria-label="Refresh"
            >
              <BsArrowClockwise size={18} />
            </button>
          </div>

          <Card.Body className="p-4">
            <form onSubmit={handleSubmit} className="form-class">
              <Form.Group className="mb-3 position-relative">
                <Form.Control
                  placeholder="Enter old password"
                  name="old_password"
                  onChange={handleChange}
                  value={formData.old_password}
                  type={showOldPassword ? 'text' : 'password'}
                  required
                  style={{
                    borderRadius: '10px',
                    border: '1px solid #D1D3D4',
                    paddingRight: '48px',
                    minHeight: '46px',
                  }}
                />
                <Button
                  variant="link-dark"
                  className="position-absolute end-0 top-50 translate-middle-y me-0 border-0"
                  style={{ border: 'none', padding: '8px 12px' }}
                  onClick={oldPasswordVisible}
                  type="button"
                >
                  {showOldPassword ? (
                    <FaEyeSlash size={20} title="Hide" />
                  ) : (
                    <FaEye size={20} title="Show" />
                  )}
                </Button>
              </Form.Group>

              <Form.Group className="mb-3 position-relative">
                <Form.Control
                  placeholder="Enter new password"
                  name="new_password"
                  onChange={handleChange}
                  value={formData.new_password}
                  type={showNewPassword ? 'text' : 'password'}
                  required
                  style={{
                    borderRadius: '10px',
                    border: '1px solid #D1D3D4',
                    paddingRight: '48px',
                    minHeight: '46px',
                  }}
                />

                <Button
                  variant="link-dark"
                  className="position-absolute end-0 top-50 border-0 translate-middle-y me-0"
                  style={{ border: 'none', padding: '8px 12px' }}
                  onClick={newPasswordVisible}
                  type="button"
                >
                  {showNewPassword ? (
                    <FaEyeSlash fontSize={20} title="Hide" />
                  ) : (
                    <FaEye fontSize={20} title="Show" />
                  )}
                </Button>
              </Form.Group>

              <Button
                type="submit"
                variant="primary"
                className="w-100 fw-semibold mt-2"
                style={{
                  letterSpacing: '0.02em',
                  borderRadius: '10px',
                  minHeight: '46px',
                  backgroundColor: '#223843',
                  border: 'none',
                }}
              >
                Change password
              </Button>
            </form>
            {newPasswordMessage && (
              <p className="alert alert-success text-center fw-semibold mt-5 " style={{backgroundColor:"#F3F4F6", border:"1px solid #D1D3D4", color:"#223843"}}>
                Your new password is
                <span style={{ letterSpacing: '2px', color: '#223843', fontWeight: 'bold'}}>
                  {' '}
                  {'"'}
                  {newPasswordMessage}
                  {'"'}
                </span>
                . Please note it before exit.
              </p>
            )}
          </Card.Body>
        </Card>
      </div>
    </div>
  )
}
